import mutations from './mutations';
import actions from './actions';

const state = {
    // 检验发帖/弹幕权限
    posterStatus: {
        hasAuthorized: false,
        canPost: true,
        blackList: [],
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
